// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"374":"dea52c06","687":"cfd446ea"}[chunkId] + ".chunk.css";
};